import { useTranslation } from 'react-i18next'

import { OrderKeys } from 'sections/LKSection/modules/OrderModule/data'
import { Flex, Text } from 'components/uiKit'

export const PickPointTypeTooltip = () => {
  const { t } = useTranslation()

  const textStyle = {
    color: 'white',
  }

  const getKey = (key: string) => `${OrderKeys.locationStep}.${key}`

  return (
    <Flex vertical gap={8}>
      <Flex vertical>
        <Text style={textStyle}>{t(getKey('Условия открытия Упрощенный'))}</Text>
        <Text style={textStyle}>{t(getKey('Возможность открыться'))}</Text>
        <Text style={textStyle}>{t(getKey('Тариф зависит от зоны'))}</Text>
      </Flex>
      <Flex vertical>
        <Text style={textStyle}>{t(getKey('Условия открытия Стандартный'))}</Text>
        <Text style={textStyle}>{t(getKey('Тариф индивидуален'))}</Text>
      </Flex>
    </Flex>
  )
}
